module.exports = __webpack_public_path__ + "img/gallery4.0b04890.jpg";